enum LocalizationMethod {
    String = 'String',
    ShortString = 'ShortString',
    LongString = 'LongString',
    ShortMonthDayString = 'ShortMonthDayString',
}

export default LocalizationMethod;
